import { useState, useContext } from "react";
import pb from "lib/pocketbase";
import DashCard from "components/dashboard/DashCard";
import SlaCard from "components/dashboard/SlaCard";
import PaceCard from "components/dashboard/PaceCard";
import CommentsCard from "components/dashboard/CommentsCard";
import Footer from "components/Footer";
// import { UserContext } from "../lib/UserContext";
//import { logout } from "./Auth";

export default function Dashboard() {
  // const [dummy, setDummy] = useState(0);
  //const { user, setUser } = useContext(UserContext);
  const [dark, setDark] = useState(true);

  console.log(`re-rendered <Dashboard/> w/ user ${pb.authStore.model.name}`);
  return (
    <div className="d-flex flex-column">
      <div className="row mb-3">
        {" "}
        <div className="col-8">
          <CommentsCard id={`${pb.authStore.model.id}`} />
        </div>
        <div className="col-4">
          <PaceCard />
        </div>
      </div>{" "}
      <div className="row ">
        <div className="col-4">
          {" "}
          <SlaCard
            title={"🔥SLA"}
            tooltip="Tickets expiring in less than 2 hrs"
          />
        </div>
        <div className="col-4">
          <DashCard view="17536598588443" title="No SLA" />
        </div>
        <div className="col-4">
          {" "}
          <DashCard view="1260856763350" title="SLA < 24" />
        </div>{" "}
      </div>{" "}
      <Footer />
    </div>
  );
}
